export const domains = [
  {
    id: "flowers",
    name: "Fresh Cut Flowers",
    tagline: "Bloom Without Boundaries",
    description: "Exquisite pesticide-free fresh cut flowers cultivated with sustainable practices for domestic and export markets.",
    image: "https://images.unsplash.com/photo-1508808703020-ef18109db02f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Zmxvd2Vyc3xlbnwwfHwwfHx8MA%3D%3D",
    icon: "Flower2",
    products: [
      {
        id: "fl-1",
        name: "Premium Rose Bunches",
        image: "https://images.unsplash.com/photo-1740989516163-fb657106626c?w=600&auto=format&fit=crop&q=60",
        description: "Hand-picked premium roses in stunning varieties. Grown organically with long-lasting freshness for events and export.",
        details: [
          "Multiple color varieties available",
          "Pesticide-free cultivation",
          "Cold-chain logistics for freshness",
          "Export-grade stem length & quality",
          "Custom arrangements available"
        ],
        benefits: "Our roses are grown using drip irrigation and organic pest control, resulting in vibrant blooms that last 50% longer than conventionally grown alternatives."
      },
      {
        id: "fl-2",
        name: "All Types of Flowers for Events",
        image: "https://images.unsplash.com/photo-1487530811176-3780de880c2d?w=800&q=80",
        description: "A wide variety of fresh cut flowers for weddings, corporate events, and celebrations. Custom bouquets and bulk supply available.",
        details: [
          "Seasonal and exotic varieties",
          "Bulk supply for events & florists",
          "Cold-chain maintained from farm",
          "Custom designs and arrangements",
          "Export packaging available"
        ],
        benefits: "We source flowers directly from certified farms ensuring peak freshness. Each variety is carefully graded and packed to maintain color vibrancy and longevity."
      }
    ]
  },

  {
    id: "seafood",
    name: "Frozen & Live Sea Food",
    tagline: "Ocean Fresh, World Delivered",
    description: "Premium quality frozen and live seafood including crabs and shrimp sourced from sustainable fisheries and aquaculture farms for global markets.",
    image: "https://images.unsplash.com/photo-1559847844-5315695dadae?w=800&q=80",
    icon: "Waves",
    products: [
      {
        id: "sf-1",
        name: "Crab",
        image: "https://images.unsplash.com/photo-1553659971-f01207815844?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y3JhYnxlbnwwfHwwfHx8MA%3D%3D",
        description: "Premium quality crabs available in size range 30–80, sourced from coastal fisheries and aquaculture farms. Available fresh, live, and frozen.",
        details: [
          "Size range: 30–80 (pieces per kg)",
          "Available as live, fresh, or IQF frozen",
          "Cleaned, graded & vacuum packed",
          "Rich in protein and omega-3",
          "Meets international food safety standards (HACCP, ISO)",
          "Bulk and retail packaging available"
        ],
        benefits: "Our crabs are sourced from certified sustainable fisheries and aquaculture farms, ensuring consistent size, freshness, and traceability from ocean to table. Ideal for restaurants, retailers, and export buyers."
      },
      {
        id: "sf-2",
        name: "Shrimp (Size 30–80)",
        image: "https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=800&q=80",
        description: "High-quality shrimp in size range 30–80, available in multiple processing forms including headless shell-on, peeled & deveined, and easy-peel.",
        details: [
          "Size range: 30–80 (pieces per kg)",
          "Available: HLSO, PD, EZ-peel, cooked",
          "Individually Quick Frozen (IQF)",
          "No added water or chemicals",
          "Low cholesterol, high protein seafood",
          "Certified for EU, USA & Middle East markets"
        ],
        benefits: "Our shrimp are farmed and processed under stringent quality controls with full traceability. Rich in lean protein, selenium, and essential amino acids, they are a premium choice for global food service and retail markets."
      }
    ]
  },

  {
    id: "fruits-vegetables",
    name: "Fruits & Vegetables",
    tagline: "Nature's Fresh Bounty",
    description: "Fresh and dried fruits and vegetables sourced directly from farms. Nutritious, hygienic, and packed with natural goodness for domestic and export markets.",
    image: "https://images.unsplash.com/photo-1610348725531-843dff563e2c?w=800&q=80",
    icon: "Sprout",
    products: [
      {
        id: "fv-1",
        name: "Fresh Vegetables",
        image: "https://images.unsplash.com/photo-1597362925123-77861d3fbac7?w=800&q=80",
        description: "Farm-fresh vegetables including leafy greens, root vegetables, gourds, and seasonal produce, carefully sorted and graded for export quality.",
        details: [
          "Tomatoes, Onions, Potatoes, Garlic",
          "Spinach, Methi, Cabbage, Cauliflower",
          "Bitter Gourd, Bottle Gourd, Drumstick",
          "Capsicum, Brinjal, Lady Finger (Okra)",
          "Pesticide-residue tested",
          "Export-grade grading & packaging"
        ],
        benefits: "Sourced directly from trusted farms and processed under hygienic conditions. Our fresh vegetables maintain peak nutritional value and shelf life through careful post-harvest handling and cold-chain management."
      },
      {
        id: "fv-2",
        name: "Fresh Fruits",
        image: "https://images.unsplash.com/photo-1619566636858-adf3ef46400b?w=800&q=80",
        description: "Premium fresh tropical and seasonal fruits, hand-selected at peak ripeness and packed for domestic supply and international export.",
        details: [
          "Alphonso & Kesar Mangoes",
          "Bananas, Pomegranates, Papayas",
          "Guava, Sapota (Chiku), Custard Apple",
          "Grapes (Thompson & Red Globe)",
          "Individually graded by size & ripeness",
          "Export-compliant cold chain packaging"
        ],
        benefits: "Each fruit is carefully selected at the right maturity stage to ensure maximum sweetness and shelf life. Our mangoes and pomegranates are especially prized in Middle Eastern and European markets."
      },
      {
        id: "fv-3",
        name: "Dried Vegetables",
        image: "https://images.unsplash.com/photo-1615485290382-441e4d049cb5?w=800&q=80",
        description: "Naturally dehydrated vegetables retaining full nutritional value, color, and flavor. Ideal for food processing, instant food, and export.",
        details: [
          "Dried Onion Flakes & Powder",
          "Dehydrated Garlic Flakes & Powder",
          "Dried Tomato Slices & Powder",
          "Dehydrated Spinach & Green Peas",
          "No artificial preservatives",
          "Long shelf life up to 18 months"
        ],
        benefits: "Our dehydrated vegetables are processed using advanced drying technology that preserves 90%+ of original nutrients. Perfect for soups, seasonings, instant noodles, and ready-to-eat meal manufacturers worldwide."
      },
      {
        id: "fv-4",
        name: "Dried Fruits",
        image: "https://images.unsplash.com/photo-1598799170795-45f90ddfb662?w=600&auto=format&fit=crop&q=60",
        description: "Naturally dried fruits with concentrated flavor and nutrients. No added sugar, preservative-free and rich in dietary fiber.",
        details: [
          "Raisins (Thompson & Golden)",
          "Dried Figs, Apricots & Dates",
          "Dried Mango Slices & Powder",
          "Amla (Indian Gooseberry) dried",
          "No added sugar or sulphur",
          "Rich in fiber, iron & antioxidants"
        ],
        benefits: "Our dried fruits are naturally sun-dried or mechanically dehydrated without chemicals. They offer a healthy, energy-dense snack option and are widely used in confectionery, cereals, and nutraceutical industries globally."
      }
    ]
  },

  {
    id: "fertilizers",
    name: "Fertilizers",
    tagline: "Natural & Scientific Nutrition for Healthy Soil",
    description: "Complete range of organic and inorganic fertilizers that enrich soil fertility, promote sustainable agriculture, and deliver high crop yields.",
    image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&q=80",
    icon: "Leaf",
    products: [
      {
        id: "fe-1",
        name: "Hen Waste (Poultry Manure)",
        image: "https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8aGVufGVufDB8fDB8fHww",
        description: "Nutrient-rich organic fertilizer derived from processed poultry waste. High in nitrogen and essential micronutrients for enhanced crop yield.",
        details: [
          "High nitrogen content",
          "Improves soil fertility naturally",
          "Enhances crop yield significantly",
          "Eco-friendly and biodegradable",
          "Available in granule and powder form"
        ],
        benefits: "Boosts plant growth naturally and improves soil microbial activity for long-term soil health."
      },
      {
        id: "fe-2",
        name: "Vermicompost",
        image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&q=80",
        description: "Premium organic compost produced through earthworm activity. Rich in humic acid, enzymes, and beneficial microorganisms.",
        details: [
          "Rich in organic matter & humic acid",
          "Improves soil aeration & drainage",
          "Enhances water retention capacity",
          "100% chemical-free fertilizer",
          "Suitable for all crops and soil types"
        ],
        benefits: "Promotes strong root development, improves soil structure, and supports truly sustainable farming practices."
      },
      {
        id: "fe-3",
        name: "Cow Dung Manure",
        image: "https://media.istockphoto.com/id/1173505320/photo/cow-dung-fuel-of-animal-waste-bio-fuels.webp?a=1&b=1&s=612x612&w=0&k=20&c=cOfss9iF6BKM0rnBjS1VOVgMO6hsn_1NM5k3HMrI2eY=",
        description: "Well-decomposed traditional organic manure from cow dung. A cornerstone of natural farming widely used across India and exported globally.",
        details: [
          "Fully decomposed & odour-controlled",
          "Improves soil texture and porosity",
          "Increases beneficial microbial activity",
          "Enhances nutrient availability",
          "Widely used in certified organic farming"
        ],
        benefits: "Strengthens soil health over time and supports long-term crop productivity while reducing dependence on chemical inputs."
      },
      {
        id: "fe-4",
        name: "Urea",
        image: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800&q=80",
        description: "Nitrogen-rich inorganic fertilizer widely used to promote rapid vegetative plant growth across a wide range of crops.",
        details: [
          "High nitrogen content (46%)",
          "Quick nutrient release",
          "Enhances leafy and vegetative growth",
          "Suitable for paddy, wheat, sugarcane & more",
          "Available in granular and prilled form"
        ],
        benefits: "Boosts vegetative growth rapidly and improves overall crop productivity. Best applied in split doses for maximum absorption."
      },
      {
        id: "fe-5",
        name: "DAP (Diammonium Phosphate)",
        image: "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=800&q=80",
        description: "Phosphorus-rich inorganic fertilizer that supports strong root development and early crop establishment.",
        details: [
          "High phosphorus content (46% P2O5)",
          "Contains 18% nitrogen",
          "Improves root strength & depth",
          "Enhances flowering and fruiting",
          "Granular form for easy application"
        ],
        benefits: "Encourages early plant growth and better crop establishment, especially critical during sowing and transplanting stages."
      },
      {
        id: "fe-6",
        name: "NPK Blends",
        image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&q=80",
        description: "Balanced inorganic fertilizer blends containing Nitrogen, Phosphorus, and Potassium in customizable ratios for diverse crop needs.",
        details: [
          "Customizable NPK ratios (e.g. 20:20:0, 12:32:16)",
          "Improves overall plant health",
          "Supports balanced vegetative & fruit growth",
          "Suitable for various soil types",
          "Available in granular and water-soluble forms"
        ],
        benefits: "Provides complete and balanced plant nutrition for higher yield and better crop quality across cereals, vegetables, fruits, and cash crops."
      }
    ]
  },

 {
  id: "dairy",
  name: "Ghee Products",
  tagline: "Pure Gold from Sacred Cows",
  description: "Premium A2 desi ghee made using traditional bilona methods from authentic desi cow milk. Rich in nutrition, aroma, and cultural heritage.",
  image: "https://images.unsplash.com/photo-1628088062854-d1870b4553da?w=800&q=80",
  icon: "Milk",
  products: [
    {
      id: "da-1",
      name: "A2 Desi Ghee",
      image: "https://media.istockphoto.com/id/1413268652/photo/ghee-butter-oil.webp?a=1&b=1&s=612x612&w=0&k=20&c=qp-uWOt9koD_794F8rJp3yw6LBXbTeMnI5AC0ll3ic0=",
      description: "Traditional bilona-method ghee made from pure A2 milk of indigenous desi cows. Golden, aromatic, and packed with healthy fats and fat-soluble vitamins.",
      details: [
        "Made from A2 Desi cow milk (Gir, Sahiwal breeds)",
        "Traditional bilona hand-churning method",
        "Rich in Omega-3, CLA & fat-soluble vitamins",
        "High smoke point — ideal for cooking & frying",
        "No preservatives, additives or adulteration",
        "Available in glass jar & food-grade tin packaging"
      ],
      benefits: "A2 Ghee made through the bilona method retains maximum nutrients and has a distinctive nutty aroma. It's a cornerstone of Indian culinary and Ayurvedic wellness traditions, increasingly sought after in global health markets."
    },
    {
      id: "da-2",
      name: "Desi Ghee",
      image: "https://media.istockphoto.com/id/1187181045/photo/pure-or-desi-ghee-clarified-melted-butter-healthy-fats-bulletproof-diet-concept-or-paleo.webp?a=1&b=1&s=612x612&w=0&k=20&c=SQlM0ESr2hxs2HsOzRTkjonfFtlHXQFVTKLfaaHWOVg=",
      description: "Pure desi ghee crafted from high-quality cow milk using traditional processes. Rich flavor, smooth texture, and perfect for everyday cooking.",
      details: [
        "Made from high-quality cow milk",
        "Traditional slow-cooking method",
        "Rich aroma and authentic taste",
        "Ideal for daily cooking, sweets, and frying",
        "No artificial preservatives or chemicals",
        "Hygienically processed and packed"
      ],
      benefits: "Desi ghee is a staple in Indian households, offering great taste and nourishment. It supports digestion, enhances flavor in meals, and provides a natural source of healthy fats for everyday energy."
    }
  ]
}
];

export const stats = [
  { value: 500, suffix: "+", label: "Partner Farmers" },
  { value: 50, suffix: "K+", label: "Products Exported" },
  { value: 15, suffix: "+", label: "Countries Served" },
  { value: 98, suffix: "%", label: "Client Satisfaction" }
];

export const testimonials = [
  {
    name: "Rajesh Kumar",
    role: "Organic Farmer, Punjab",
    text: "Aurexium Global's fertilizer products transformed our soil quality. Our wheat yield increased by 35% in just one season. Truly remarkable.",
    avatar: "RK"
  },
  {
    name: "Sarah Mitchell",
    role: "Import Manager, UK",
    text: "We've been importing dairy and seafood products from Aurexium for 3 years. Impeccable quality, reliable logistics, and excellent communication.",
    avatar: "SM"
  },
  {
    name: "Amit Patel",
    role: "Dairy Distributor, Gujarat",
    text: "The A2 Desi Ghee from Aurexium Global is the finest quality we've sourced. Our customers keep coming back for more. Outstanding product.",
    avatar: "AP"
  }
];